import React, { useMemo } from 'react';
import { Content } from '@leverege/ui-elements';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import TableView from "../table/TableView.js";
import TablePagination from "../table/TablePagination.js";
import { useRowProps } from "../table/hooks/index.js";
import ErrorView from "../views/ErrorView.js";
import NoDataView from "../views/NoDataView.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon,
  exists
} = I18N.ns('molten.dataViewers.history.HistoryTableView');
export default function HistoryTableView(props) {
  const {
    variant = 'history',
    paginator,
    onUpdateModel,
    context,
    footerMatchContext,
    settings,
    relationship: {
      path
    },
    error
  } = props;
  const afterHooks = useMemo(() => {
    return [useRowProps];
  }, []);
  let noDataMessage;
  if (error) {
    noDataMessage = Config.get(HistoryTableView.CLIENT, 'errorMessage', ErrorView);
  } else {
    noDataMessage = Config.get(HistoryTableView.CLIENT, 'noDataMessage', NoDataView);
  }
  if (noDataMessage != null && typeof noDataMessage !== 'string') {
    // assume its a component class/function
    const Clazz = noDataMessage;
    noDataMessage = /*#__PURE__*/_jsx(Clazz, {
      ...props,
      client: HistoryTableView.CLIENT,
      t: t,
      tIcon: tIcon,
      exists: exists
    });
  }
  return /*#__PURE__*/_jsxs(Content, {
    children: [/*#__PURE__*/_jsx(Content.Area, {
      children: /*#__PURE__*/_jsx(TableView, {
        ...props,
        noDataMessage: noDataMessage,
        model: settings,
        settings: settings,
        context: context,
        path: path,
        variant: variant,
        paginate: false,
        pageItems: paginator.pageItems,
        afterHooks: afterHooks,
        onUpdateTableModel: onUpdateModel
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      children: /*#__PURE__*/_jsx(TablePagination, {
        context: context,
        matchContext: footerMatchContext,
        paginator: paginator
      })
    })]
  });
}